import { useEffect } from "react";
import BreadCrumb from "../../components/BreadCrumb";

const Index = ({
    breadcrumbList,
    pageDetails,
    descriptionRef,
    isLoading
}) => {

    const scopeStyles = (html) => {
        return html.replace(/<style([^>]*)>([\s\S]*?)<\/style>/gi, (match, attr, css) => {
            // Prefix every selector inside the style tag with .full_description_text
            const scopedCss = css.replace(/(^|\})\s*([^{]+)/g, (fullMatch, brace, selector) => {
                if (selector.includes('@')) return fullMatch; // Skip @media, @keyframes
                return `${brace} .full_description_text ${selector}`;
            });
            return `<style${attr}>${scopedCss}</style>`;
        });
    };

    useEffect(() => {
        const container = descriptionRef.current;
        const tempDiv = document.createElement('div');
        tempDiv.innerHTML = pageDetails?.content;
        const scriptTags = tempDiv.querySelectorAll('script');
        scriptTags.forEach((oldScript) => {
            const newScript = document.createElement('script');
            for (let attr of oldScript.attributes) {
                newScript.setAttribute(attr.name, attr.value);
            }
            newScript.text = oldScript.textContent;

            container.appendChild(newScript);
        });
    }, [pageDetails?.content]);


    return (
        <>
            <div className="container">
                <BreadCrumb list={breadcrumbList} />
            </div>
            {
                isLoading ?


                    <section class="contact_seaction">
                        <div class="contact_us">
                            <div class="container">
                                <div class="contact_box">
                                    <div class="contact_our">
                                        <div class="card_box skeleton">
                                            <div class="top_box">
                                                <h6>Office</h6>
                                                <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M8.09361 6.41708C12.481 1.8613 19.594 1.86114 23.9813 6.41708C28.3685 10.9731 28.3684 18.36 23.9813 22.9161L18.5331 28.5743C17.1545 30.0041 14.9206 30.0036 13.5419 28.5733L8.09263 22.9161C3.70557 18.3599 3.7063 10.973 8.09361 6.41708ZM22.619 7.83114C18.9838 4.05643 13.0901 4.05631 9.45494 7.83114C5.8197 11.6061 5.81992 17.727 9.45494 21.502L14.9032 27.1593C15.5298 27.8092 16.5455 27.8089 17.1717 27.1593L22.62 21.502C26.2549 17.7269 26.2541 11.6061 22.619 7.83114ZM16.036 9.6661C18.6949 9.66633 20.8513 11.9049 20.8514 14.6661C20.8514 17.4274 18.695 19.6659 16.036 19.6661C13.377 19.6659 11.2215 17.4274 11.2215 14.6661C11.2217 11.9049 13.3771 9.6663 16.036 9.6661ZM16.036 11.6661C14.4408 11.6663 13.1475 13.0095 13.1473 14.6661C13.1473 16.3228 14.4407 17.6659 16.036 17.6661C17.6313 17.6659 18.9256 16.3228 18.9256 14.6661C18.9255 13.0095 17.6312 11.6663 16.036 11.6661Z" fill="#ECBB33" />
                                                </svg>
                                            </div>
                                            <div class="bottom_box">
                                                <h5>Pineapple Loft, 22 Pink Street, New York</h5>
                                            </div>
                                        </div>
                                        <div class="card_box skeleton">
                                            <div class="top_box">
                                                <h6>Email</h6>
                                                <svg width="31" height="32" viewBox="0 0 31 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M4.97512 8.84632C5.17573 8.16343 5.78723 7.66666 6.51046 7.66666H24.4858C25.209 7.66666 25.8205 8.16343 26.0211 8.84632L15.4981 16.1315L4.97512 8.84632ZM2.97964 9.31501C2.97946 9.32568 2.97945 9.33634 2.97959 9.347V22.6667C2.97959 24.6917 4.56042 26.3333 6.51046 26.3333H24.4858C26.4358 26.3333 28.0166 24.6917 28.0166 22.6667V9.34696M26.0907 11.2018V22.6667C26.0907 23.5871 25.3722 24.3333 24.4858 24.3333H6.51046C5.62408 24.3333 4.90552 23.5871 4.90552 22.6667V11.2018L14.964 18.1654C15.2874 18.3893 15.7088 18.3893 16.0323 18.1654L26.0907 11.2018ZM28.0166 9.31505C28.0071 7.29841 26.4299 5.66666 24.4858 5.66666H6.51046C4.5663 5.66666 2.98914 7.29839 2.97964 9.31501" fill="#ECBB33" />
                                                </svg>
                                            </div>
                                            <div class="bottom_box">
                                                <h5>info@toursxplorer.com</h5>
                                            </div>
                                        </div>
                                        <div class="card_box skeleton">
                                            <div class="top_box">
                                                <h6>Phone</h6>
                                                <svg width="31" height="32" viewBox="0 0 31 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M11.7432 4.33301C12.0929 4.33313 12.4119 4.52978 12.5811 4.83984L12.6367 4.96191L15.2051 11.6279C15.363 12.0379 15.2417 12.5008 14.9209 12.7734L14.8066 12.8574L12.3818 14.3662L12.3965 14.3916C13.4653 16.2969 14.9609 17.9045 16.7539 19.0771L17.166 19.334L18.6211 16.8184C18.84 16.44 19.2678 16.2598 19.6709 16.3604L19.8037 16.4043L26.2236 19.0713C26.5485 19.2062 26.7741 19.512 26.8203 19.8652L26.8291 20V25.333C26.8291 27.358 25.2486 28.9998 23.2402 28.998C12.39 28.3133 3.73747 19.3282 3.07617 8C3.07638 6.05027 4.54201 4.45545 6.3916 4.33984L6.60742 4.33301H11.7432ZM6.60547 6.33301C5.71923 6.33302 5.00102 7.07981 4.99902 7.93945C5.59956 18.1978 13.4768 26.3784 23.2969 27C24.1278 27 24.8114 26.3433 24.8936 25.5029L24.9014 25.333V20.6768L19.8486 18.5771L18.3447 21.1807C18.1103 21.5864 17.6392 21.7608 17.2178 21.6162L17.0928 21.5635C14.1148 20.0382 11.7041 17.535 10.2354 14.4424C10.0341 14.0183 10.1483 13.5122 10.4932 13.2227L10.6035 13.1426L13.1104 11.5801L11.0889 6.33301H6.60547ZM19.4453 8.33301C21.3954 8.33301 22.9766 9.97496 22.9766 12C22.9766 12.5523 22.5455 13 22.0137 13C21.5262 13 21.1234 12.6238 21.0596 12.1357L21.0508 12C21.0508 11.1371 20.4187 10.4271 19.6094 10.3418L19.4453 10.333C18.9137 10.3328 18.4824 9.88515 18.4824 9.33301C18.4826 8.78101 18.9138 8.33324 19.4453 8.33301ZM19.4453 3C24.2318 3 28.1123 7.02944 28.1123 12C28.1123 12.5523 27.6812 13 27.1494 13C26.6176 13 26.1865 12.5523 26.1865 12C26.1865 8.13401 23.1681 5 19.4453 5C18.9137 4.99977 18.4824 4.55214 18.4824 4C18.4824 3.44786 18.9137 3.00023 19.4453 3Z" fill="#ECBB33" />
                                                </svg>
                                            </div>
                                            <div class="bottom_box">
                                                <h5>+1 (123) 45-67-890</h5>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="map_view_box skeleton">
                                <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d235013.74843718624!2d72.41493399983852!3d23.020474096845316!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x395e848aba5bd449%3A0x4fcedd11614f6516!2sAhmedabad%2C%20Gujarat!5e0!3m2!1sen!2sin!4v1747135332178!5m2!1sen!2sin" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
                            </div>
                        </div>
                    </section> :

                    <div
                        id='full_description_text_activity'
                        className="comon-tags-class contact-us-content"
                        ref={descriptionRef}
                        dangerouslySetInnerHTML={{ __html: pageDetails?.content ? scopeStyles(pageDetails?.content).replace(/<script[\s\S]*?>[\s\S]*?<\/script>/gi, '') : "" }}

                    />
            }
        </>
    )

}
export default Index;